module.exports = __webpack_public_path__ + "static/media/child-care.5a810578.jpg";